module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardContainer"
  }, [_c('div', {
    staticClass: "card",
    on: {
      "click": _vm.openPresentation
    }
  }, [_c('div', {
    staticClass: "top-half"
  }, [_c('div', {
    staticClass: "presenter"
  }, [(_vm.presenterInfo) ? _c('img', {
    staticClass: "presenterPhoto",
    attrs: {
      "src": _vm.presenterInfo.pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : (_vm.presenterProfiles) ? _c('img', {
    staticClass: "presenterPhoto",
    attrs: {
      "src": _vm.presenterProfiles.profiles[0].pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : _c('img', {
    staticClass: "presenterPhoto",
    attrs: {
      "src": require("../assets/icons/anonymous.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slidePreview"
  }, [_c('img', {
    staticClass: "slidePicture",
    attrs: {
      "src": _vm.presentation.previewUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-half"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.presentation.title))]), _vm._v(" "), (_vm.presenterInfo) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.presenterInfo.displayName))]) : (_vm.presenterProfiles) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.presenterProfiles.profiles[0].displayName))]) : _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('str.DialogLoop')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26e91a0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionCard.vue
// module id = 465
// module chunks = 0